// Interactions de la landing page : ancrage vers le formulaire, auto-complétion
// de la raison sociale, validation du téléphone, suivi de campagne.
// Aucune dépendance : ni jQuery, ni jQuery UI.
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    ancresVersFormulaire();
    var form = document.getElementById("formHotel");
    if (form) {
      autocompleteRaisonSociale(form);
      validationTelephone(form);
    }
    suiviDeCampagne();
  });

  // --- Boutons d'appel à l'action qui ramènent au formulaire ---------------
  function ancresVersFormulaire() {
    var boutons = document.querySelectorAll(".fidelisez .btn a, .incontournable .btn a");
    boutons.forEach(function (bouton) {
      bouton.addEventListener("click", function (event) {
        var cible = document.getElementById("formulaire-contact");
        if (!cible) return;
        event.preventDefault();
        cible.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }

  // --- Auto-complétion de la raison sociale --------------------------------
  // Liste construite à la main plutôt qu'un <datalist> natif : celui-ci ne
  // permet pas d'afficher un libellé différent de la valeur insérée, et n'expose
  // pas l'entrée choisie. Il faudrait redemander l'établissement à l'API par son
  // nom, ce qui renvoie le mauvais SIRET dès qu'il y a des homonymes.
  var API = "https://recherche-entreprises.api.gouv.fr/search";
  var LONGUEUR_MIN = 3;
  var DELAI_FRAPPE = 300;

  function autocompleteRaisonSociale(form) {
    var champ = form.querySelector("#rsociale");
    var liste = form.querySelector("#rsociale-liste");
    var statut = form.querySelector("#rsociale-statut");
    var champCp = form.querySelector("#cp");
    var champSiret = form.querySelector("#siret");
    var champNaf = form.querySelector("#naf");
    if (!champ || !liste) return;

    var suggestions = [];
    var indexActif = -1;
    var minuteur;
    var requeteEnCours = 0;

    function codePostal() {
      var v = champCp ? champCp.value.trim() : "";
      return /^\d{5}$/.test(v) ? v : "";
    }

    function fermer() {
      liste.hidden = true;
      liste.innerHTML = "";
      suggestions = [];
      indexActif = -1;
      champ.setAttribute("aria-expanded", "false");
      champ.removeAttribute("aria-activedescendant");
    }

    function marquerActif(i) {
      var options = liste.querySelectorAll("[role='option']");
      options.forEach(function (o, j) {
        var actif = j === i;
        o.classList.toggle("is-active", actif);
        o.setAttribute("aria-selected", actif ? "true" : "false");
      });
      indexActif = i;
      if (i >= 0) {
        champ.setAttribute("aria-activedescendant", options[i].id);
        options[i].scrollIntoView({ block: "nearest" });
      } else {
        champ.removeAttribute("aria-activedescendant");
      }
    }

    function afficher(resultats) {
      suggestions = resultats;
      liste.innerHTML = "";
      if (!resultats.length) {
        fermer();
        if (statut) statut.textContent = "Aucun établissement trouvé.";
        return;
      }
      resultats.forEach(function (r, i) {
        var li = document.createElement("li");
        li.id = "rsociale-option-" + i;
        li.className = "combobox__option";
        li.setAttribute("role", "option");
        li.setAttribute("aria-selected", "false");
        // La commune n'apparaît que dans la liste : elle distingue les homonymes
        // sans polluer le champ une fois la sélection faite.
        li.textContent = r.commune ? r.nom + " — " + r.commune : r.nom;
        li.addEventListener("mousedown", function (e) {
          // mousedown et non click : le blur du champ fermerait la liste avant.
          e.preventDefault();
          choisir(i);
        });
        liste.appendChild(li);
      });
      liste.hidden = false;
      champ.setAttribute("aria-expanded", "true");
      marquerActif(-1);
      if (statut) {
        statut.textContent = resultats.length === 1
          ? "1 établissement proposé."
          : resultats.length + " établissements proposés.";
      }
    }

    function choisir(i) {
      var r = suggestions[i];
      if (!r) return;
      champ.value = r.nom;
      if (champSiret) champSiret.value = r.siret;
      if (champNaf) champNaf.value = r.naf;
      fermer();
      if (statut) statut.textContent = "";
    }

    function rechercher(terme) {
      var cp = codePostal();
      var url = API + "?q=" + encodeURIComponent(terme) +
        (cp ? "&code_postal=" + encodeURIComponent(cp) : "") + "&per_page=20";
      var jeton = ++requeteEnCours;
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : { results: [] }; })
        .catch(function () { return { results: [] }; })
        .then(function (data) {
          // Une réponse arrivée après une frappe plus récente est périmée.
          if (jeton !== requeteEnCours) return;
          afficher((data.results || [])
            .filter(function (el) { return el.nom_raison_sociale; })
            .map(function (el) {
              var siege = el.siege || {};
              return {
                nom: el.nom_raison_sociale,
                commune: siege.libelle_commune || "",
                siret: siege.siret || "",
                naf: siege.activite_principale || ""
              };
            }));
        });
    }

    champ.addEventListener("input", function () {
      // SIRET et NAF ne sont renseignés que par un choix dans la liste. Toute
      // frappe libre les remet à vide : mieux vaut un champ vide qu'un SIRET qui
      // ne correspond plus à la raison sociale affichée.
      if (champSiret) champSiret.value = "";
      if (champNaf) champNaf.value = "";
      var terme = champ.value.trim();
      clearTimeout(minuteur);
      if (terme.length < LONGUEUR_MIN) { fermer(); return; }
      minuteur = setTimeout(function () { rechercher(terme); }, DELAI_FRAPPE);
    });

    champ.addEventListener("keydown", function (e) {
      if (liste.hidden) {
        if (e.key === "ArrowDown" && champ.value.trim().length >= LONGUEUR_MIN) {
          rechercher(champ.value.trim());
          e.preventDefault();
        }
        return;
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        marquerActif((indexActif + 1) % suggestions.length);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        marquerActif(indexActif <= 0 ? suggestions.length - 1 : indexActif - 1);
      } else if (e.key === "Enter") {
        if (indexActif >= 0) { e.preventDefault(); choisir(indexActif); }
      } else if (e.key === "Escape") {
        fermer();
      } else if (e.key === "Tab") {
        fermer();
      }
    });

    champ.addEventListener("blur", function () { fermer(); });

    // Changer de code postal invalide les suggestions affichées.
    if (champCp) champCp.addEventListener("input", function () { if (!liste.hidden) fermer(); });
  }

  // --- Validation du téléphone --------------------------------------------
  function validationTelephone(form) {
    var champ = form.querySelector("#tel");
    var message = form.querySelector("#errorp");
    if (!champ) return;
    form.addEventListener("submit", function (e) {
      var valeur = champ.value.trim();
      if (!/^\d{10}$/.test(valeur)) {
        e.preventDefault();
        if (message) message.textContent = "Le numéro de téléphone doit contenir 10 chiffres";
        champ.setAttribute("aria-invalid", "true");
        champ.focus();
        return;
      }
      if (message) message.textContent = "";
      champ.removeAttribute("aria-invalid");
    });
  }

  // --- Suivi de campagne ---------------------------------------------------
  function suiviDeCampagne() {
    var params = new URLSearchParams(window.location.search);
    var levier = document.getElementById("src");
    var support = document.getElementById("cmp_support");
    if (levier) levier.value = params.get("levier") || "organique";
    if (support) support.value = params.get("cmp_support") || "organique";
  }
})();
